const ELECTRICITY_POSTPAID_URL = `${process.env.API_V4_HOST}/electricities/postpaid-transactions`;

export const getElectricityPostpaidTransaction = ($axios, transactionId) =>
  $axios.$get(`${ELECTRICITY_POSTPAID_URL}/${transactionId}`);
